import { render } from "./currency-icon.vue?vue&type=template&id=4525a9d3"
import script from "./currency-icon.vue?vue&type=script&lang=js"
export * from "./currency-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__